export const SET_CURRENT_USER = "user/SET_CURRENT_USER";
